import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_INVOICES } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const invoices = {
  namespaced: true,
  state: buildInitialState({
    invoiceList: [],
    totalRecords: 0
  }),
  getters: {
    getField
  },
  actions: {
    getInvoicesWithFilters ({ dispatch, rootGetters }, paginationParams = {}) {
      return dispatch('getInvoices', {
        ...rootGetters['invoiceFilters/getSearchObject'],
        ...paginationParams
      })
    },
    getInvoices ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading invoices, please wait...' })

      return api.doGet({ path: PATH_INVOICES, parameters: filters })
        .then(json => json.data)
        .then(paginatedResult => {
          commit('updateStatus', { status: COMPLETE })
          commit('setInvoices', paginatedResult)
          return paginatedResult
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load invoices')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setInvoices (state, { result, totalRecords } = {}) {
      state.invoiceList = Array.isArray(result) ? result : []
      state.totalRecords = totalRecords || 0
    }
  }
}

export default invoices
